<div class="menubar-hoverable header-fixed menubar-pin" style="font-family: 'Roboto', sans-serif, Helvetica, Arial, sans-serif;font-size: 13px;line-height: 1.846153846;color: #313534;background-color: #ffffff;">
  <div id="base">
    <div class="offcanvas">
    </div>
    <div id="content">
      <section class="has-actions style-default-bright">
        <div class="row">
          <div class="col-lg-6" style="width: 100%">
            <h2 class="text-primary">{{ 'messagingServiceManagement' | translate }}</h2>
            <article class="margin-bottom-xxl">
              <p class="lead">
                {{ 'manageSmsSendingFromSchoolToParents' | translate }}
                <!--<span style="color: var(--filter-dropdown-color)">
                  <select [(ngModel)]="academicInfo.current_academic" (change)="academicChanged()" style="border:none">
                    <option *ngFor="let ac of academicInfo.academicList" [ngValue]="ac.pkAcademicId">
                        {{ ac.Year }}{{ac.current ? '(Current)':ac.completed ? '(Old)':'(New)'}}
                    </option>

                  </select>
                </span>--> <!--<span style="color: var(--filter-dropdown-color)">{{feeDashDetails.academicYear}}</span>-->.
              </p>
            </article>
          </div>
        </div>
        <div class="row">
          <!-- BEGIN LAYOUT LEFT SIDEBAR -->
          <div class="col-md-12">
            <div class="card tabs-left style-default-light">
              <ul class="card-head nav nav-tabs" data-toggle="tabs" style="cursor: pointer">
                <li class="active" id="subscription_tab"><a style="cursor: pointer;" (click)="fetchSubscriptionDetails();showMainPage = false" data-target="#subscription" data-toggle="tab">{{ 'subscription' | translate }}</a></li>
                <li id="messaging_tab"><a style="cursor: pointer;" (click)="showMessagePage()" data-target="#sms_message" data-toggle="tab">{{ 'message' | translate }}</a></li>
              </ul>
              <div class="card-body tab-content style-default-bright" style="min-height: 400px;">
                <!-- For subscription Tab-->
                <div class="tab-pane active" id="subscription">
                  <div class="col-md-12" style="padding: 0;">
                    <div class="card-underline">
                      <div class="card-head">
                        <ul class="nav nav-tabs pull-right" data-toggle="tabs" style="cursor: pointer">
                          <li class="active"><a data-target="#subscription_status" data-toggle="tab">{{ 'subscriptionStatus' | translate }}</a></li>
                          <li><a data-target="#purchaseSms" data-toggle="tab">{{ 'purchaseSms' | translate }}</a></li>
                        </ul>
                        <header style="padding: 0;">
                          <p class="lead" style="font-size: 17px;color: grey;margin: 0;">{{ 'subscriptionManagement' | translate }}</p>
                          <p style="font-size: 12px;color: grey;margin: 0;">{{ 'viewAndManageMessageSubscription' | translate }}</p>
                        </header>
                      </div>
                      <div class="card-body tab-content">
                        <div class="tab-pane active" id="subscription_status">
                          <div class="row">
                            <div class="col-md-4">
                              <div class="card">
                                <div class="card-body no-padding">
                                  <div class="alert alert-callout alert-success no-margin">
                                    <strong class="pull-right text-lg" style="position: relative;margin-top: -2em;background: #4caf50;color: white;padding: 10px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);"><i class="md md-sms"></i></strong>
                                    <p class="opacity-50">{{ 'purchased' | translate }}</p>
                                    <app-loader loadingStyle="Dots" *ngIf="totalSubscriptionMessages === ''"></app-loader>
                                    <strong class="text-xl" *ngIf="totalSubscriptionMessages !== ''">{{totalSubscriptionMessages}}</strong>
                                  </div>
                                </div><!--end .card-body -->
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card">
                                <div class="card-body no-padding">
                                  <div class="alert alert-callout alert-warning no-margin">
                                    <strong class="pull-right text-lg" style="position: relative;margin-top: -2em;background: #ff9800;color: white;padding: 10px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);"><i class="md md-speaker-notes"></i></strong>
                                    <p class="opacity-50">{{ 'remaining' | translate }}</p>
                                    <app-loader loadingStyle="Dots" *ngIf="smsRemaining === ''"></app-loader>
                                    <strong class="text-xl" *ngIf="smsRemaining !== ''">{{smsRemaining}}</strong>
                                  </div>
                                </div><!--end .card-body -->
                              </div>
                            </div>
                            <div class="col-md-4">
                              <div class="card">
                                <div class="card-body no-padding">
                                  <div class="alert alert-callout alert-danger no-margin">
                                    <strong class="pull-right text-lg" style="position: relative;margin-top: -2em;background: #f44336;color: white;padding: 10px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);"><i class="md md-message"></i></strong>
                                    <p class="opacity-50">{{ 'used' | translate }}</p>
                                    <app-loader loadingStyle="Dots" *ngIf="sentSms === ''"></app-loader>
                                    <strong class="text-xl" *ngIf="sentSms !== ''">{{sentSms}}</strong>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="fetchSubscriptionData" style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                            <div class="col-md-12" style="text-align: center;">
                              <img src="assets/img/search_icon_animation.gif" style="width: 300px;">
                              <h3 style="margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'pleaseWait' | translate }}</h3>
                            </div>
                          </div>
                          <div *ngIf="!fetchSubscriptionData && subscriptionList.length > 0" class="table-responsive">
                            <table id="subscriptionListTable" class="table table-striped ">
                              <thead>
                              <tr>
                                <th>{{ 'requestedDate' | translate }}</th>
                                <th>{{ 'description' | translate }}</th>
                                <th>{{ 'smsQuantity' | translate }}</th>
                                <th>{{ 'smsStatus' | translate }}</th>
                                <th>{{ 'approvedDate' | translate }}</th>
                              </tr>
                              </thead>
                              <tbody>
                              <tr *ngFor="let s of subscriptionList">
                                <td>{{s.requestedOn ? (s.requestedOn | date:'yMMMd') : ''}}</td>
                                <td title="{{s.description}}">{{checkSmsDescriptionLength(s.description)}}</td>
                                <td>{{s.quantity}}</td>
                                <td>{{s.requestStatus}}</td>
                                <td>{{s.approvedOn ? (s.approvedOn | date:'yMMMd') : 'NA'}}</td>
                              </tr>
                              </tbody>
                            </table>
                          </div>
                          <div *ngIf="!fetchSubscriptionData && subscriptionList.length == 0" class="col-md-12 text-center" style="padding-top: 3em;color: teal;">
                            <h3 style="font-weight: 900;letter-spacing: 1px;">{{ 'schoolHaventPurchaseAnySmsYet' | translate }}</h3>
                          </div>
                        </div>
                        <div class="tab-pane" id="purchaseSms">
                          <div class="col-md-12">
                            <div *ngIf="!showPendingPage">
                              <div class="card-body">
                                <div class="col-md-12 text-center" style="margin-top: -3em;">
                                  <p class="lead" style="font-size: 17px;color: grey;margin: 0;font-weight: bold;">{{ 'sendRequest' | translate }}</p>
                                  <p style="font-size: 12px;color: grey;margin: 0;font-weight: 500;">{{ 'sendARequestToBluewingsAdminForSmsAccess' | translate:{ brandName: brand.name } }}</p>
                                </div>
                              </div>
                              <div class="col-md-8 col-md-offset-2">
                                <form>
                                  <div class="form-group">
                                    <label for="smsquantity"><b>{{ 'smsQuantity' | translate }}</b></label>
                                    <input type="text" class="form-control" maxlength="6" name="quantity" (keyup)="validateNumber()" [(ngModel)]="smsQuantity" id="smsquantity">
                                  </div>
                                  <div class="form-group">
                                    <label for="descriptionforsms"><b>{{ 'description' | translate }}</b></label>
                                    <textarea class="form-control" maxlength="250" name="description" (keyup)="checkDescriptionLength()" [(ngModel)]="smsDescription" id="descriptionforsms" rows="3"></textarea>
                                  </div>
                                  <span style="margin-top: -20px;font-size: 11px;float: right;color: darkgrey;">{{descriptionLength}} {{ 'characterRemains' | translate }}</span>
                                  <button type="button" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" (click)="sendSmsRequest()">{{ 'sendRequest' | translate }}</button>
                                </form>
                              </div>
                            </div>
                            <div *ngIf="showPendingPage" class="col-md-12 text-center" style="padding-top: 5em;">
                              <span style="font-size: 15px;font-weight: bold;color: orangered;">{{ 'yourSmsRequestIsInPendingStatePleaseContactBluewingsAdministratorToActivateSmsFeature' | translate:{ brandName: brand.name } }}</span>
                            </div>
                          </div>
                        </div>
                      </div><!--end .card-body -->
                    </div>
                  </div>
                </div>
                <!-- For subscription Tab -->
                <!-- For sms_messaging-->
                <div class="tab-pane" id="sms_message">
                  <div class="col-md-12" style="padding: 0;">
                    <div class="card-underline">
                      <div class="card-head">
                        <ul class="nav nav-tabs pull-right" data-toggle="tabs" style="cursor: pointer">
                          <li class="active"><a (click)="sendSmsTab();showMainPage = true;current_tab = 'SEND_SMS'" data-target="#send_sms" data-toggle="tab">{{ 'sendSms' | translate }}</a></li>
                          <li><a (click)="fetchAllSmsForView('message_sms_lists',getAuthToken);showMainPage = false;current_tab = 'SMS_HISTORY'" data-target="#view_sms" data-toggle="tab">{{ 'smsHistory' | translate }}</a></li>
                          <li><a (click)="fetchReason_sms();showMainPage = false;current_tab = 'REASON'" data-target="#reason_manage" data-toggle="tab">{{ 'reason' | translate }}</a></li>
                        </ul>
                        <header style="padding: 0;">
                          <p class="lead" style="font-size: 17px;color: grey;margin: 0;">{{ 'messageManagement' | translate }}</p>
                          <p style="font-size: 12px;color: grey;margin: 0;">{{ 'viewAndManageMessage' | translate }}</p>
                        </header>
                      </div>
                      <div class="card-body tab-content">
                        <div [style.display]="showMainPage ? '':'none'" class="col-md-12" style="position: absolute;background-color: rgb(242, 243, 243);left: 0;margin-top: -2em;">
                          <div class="col-md-12" style="padding-top: 1em;">
                            <h5 style="letter-spacing: 2px;font-size: 15px;text-transform: uppercase;text-decoration: underline;color: gray;">{{ 'filterRecipients' | translate }}</h5>
                          </div>
                          <div class="col-md-12" style="padding: 1em;">
                            <label class="smsSelection col-md-3">{{ 'everyone' | translate }}
                              <input type="radio" (change)="smsSendTo()" value="everyone" [(ngModel)]="sendTo" name="radio">
                              <span class="checkmark"></span>
                            </label>
                            <label class="smsSelection col-md-2">{{ 'STAFF' | translate }}
                              <input type="radio" (change)="smsSendTo()" value="staff" [(ngModel)]="sendTo" name="radio">
                              <span class="checkmark"></span>
                            </label>
                            <label class="smsSelection col-md-2">{{ 'STUDENT' | translate }}
                              <input type="radio" (change)="smsSendTo()" value="student" [(ngModel)]="sendTo" name="radio">
                              <span class="checkmark"></span>
                            </label>
                          </div>
                          <div *ngIf="showDropDownForStudent" class="col-md-12">
                            <label class="form-group col-md-3">
                              <select class="form-control" (change)="smsSendTo()" name="studentType" [(ngModel)]="studentType" style="text-transform: uppercase;border: 1px solid lightgray;color: gray;">
                                <option value="NONE">{{ 'selectType' | translate }}</option>
                                <option value="ALL_STUDENT">{{ 'allStudent' | translate }}</option>
                                <option value="CLASS_WISE">{{ 'classWise' | translate }}</option>
                              </select>
                            </label>
                            <label [style.display]="showClassList ? '':'none'" class="form-group col-md-3">
                              <select class="form-control" (change)="getClassListForSms($event.target.value)" style="text-transform: uppercase;border: 1px solid lightgray;color: gray;">
                                <option value="0">{{ 'selectClass' | translate }}</option>
                                <option *ngFor="let cl of getClassSectionList" value="{{cl.classId}}">{{cl.className}}</option>
                              </select>
                            </label>
                            <div [style.display]="showClassList ? '':'none'" class="col-md-6" style="background-color: white;height: 2.8em;overflow: overlay;">
                                <span *ngFor="let c of addClassForSms" style="background-color: var(--brand-primary-color);color: white;padding: 2px 5px;border-radius: 7%;margin-right: 2px;">{{c.className}} <span (click)="removeClass(c.classId)" style="cursor: pointer"><i class="fa fa-close"></i></span></span>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane active" id="send_sms">
                          <div [style.display]="sendSmsForm ? '':'none'" class="row" [style.padding-top]="sendTo == 'student' ? '13em':'9em'">
                            <div class="col-md-12 card" style="padding-bottom: 1em;">
                              <div class="card-body">
                                <div class="col-md-12 text-center" style="background-color: #dcdcdc26;padding: 1em;">
                                  <p class="lead" style="font-size: 17px;color: grey;margin: 0;font-weight: bold;">{{ 'sendMessage' | translate }}</p>
                                  <p style="font-size: 12px;color: grey;margin: 0;font-weight: 500;">{{ 'sendMessageTo' | translate }} {{sendTo}}</p>
                                </div>
                              </div>
                              <div class="col-md-8 col-md-offset-2">
                                <form>
                                  <div class="col-md-12" style="padding-top: 1em;">
                                    <label class="appSelection col-md-4">{{ 'appUser' | translate }}
                                      <input type="radio" (change)="getUserCount()" value="APP_USER" [(ngModel)]="appUserType" name="radio">
                                      <span class="radioMark"></span>
                                    </label>
                                    <label class="appSelection col-md-4">{{ 'nonAppUser' | translate }}
                                      <input type="radio" (change)="getUserCount()" value="NON_APP_USER" [(ngModel)]="appUserType" name="radio">
                                      <span class="radioMark"></span>
                                    </label>
                                    <label class="appSelection col-md-4">{{ 'bothUser' | translate }}
                                      <input type="radio" (change)="getUserCount()" value="BOTH_USER" [(ngModel)]="appUserType" name="radio">
                                      <span class="radioMark"></span>
                                    </label>
                                  </div>
                                  <!--<label class="form-group col-md-12" style="padding-top: 1em;">
                                    <select name="reason" class="form-control" style="color: darkgrey">
                                      <option value="0">SELECT REASON</option>
                                      <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                                    </select>
                                  </label>
                                  <div class="form-group col-md-12">
                                    &lt;!&ndash;<label for="descriptionforsms"><b>Message</b></label>&ndash;&gt;
                                    <textarea class="form-control" placeholder="Type your message here" name="message" rows="3" style="color: darkgrey;"></textarea>
                                  </div>
                                  <div class="col-md-12">
                                    <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="modal" data-target="#smsAlertModel" aria-expanded="true">Send Message</button>
                                  </div>-->
                                </form>
                              </div>
                              <app-sendSms [userType]="appUserType" [user_count]="total_user_count" [sendTo]="sendTo" [studentType]="studentType" [classList]="addClassForSms"></app-sendSms>
                            </div>
                          </div>
                        </div>
                        <div class="tab-pane" id="view_sms">
                          <div class="table-responsive">
                            <table id="message_sms_lists" class="table table-striped" cellspacing="0" width="100%" role="grid">
                              <thead>
                              <tr class="text-center">
                                <th style="display: none;">{{ 'messageId' | translate }}</th>
                                <th>{{ 'sentOn' | translate }}</th>
                                <th>{{ 'receiver' | translate }}</th>
                                <th>{{ 'message' | translate }}</th>
                                <th>{{ 'openingCount' | translate }}</th>
                                <th>{{ 'closingCount' | translate }}</th>
                                <th>{{ 'receiverCount' | translate }}</th>
                                <th>{{ 'viewDetails' | translate }}</th>
                              </tr>
                              </thead>
                              <tbody>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div class="tab-pane" id="reason_manage">
                          <div class="row">
                            <div class="col-md-12 card" style="padding: 10px;">
                              <div class="col-md-12" style="padding: 0px;border-bottom: 1px solid #dedede;padding-bottom: 10px;">
                                <div class="col-md-6">
                                  <p class="lead" style="font-size: 17px;color: grey;margin: 0;">{{ 'manageReason' | translate }}</p>
                                  <p style="font-size: 12px;color: grey;margin: 0;">{{ 'viewAndManageReasonToSendSms' | translate }}</p>
                                </div>
                                <div class="col-md-6 text-right" style="padding-top: 1em;">
                                  <button type="button" data-toggle="modal" data-target="#createReason" class="btn btn-raised ink-reaction btn-info" aria-expanded="true" style="margin-left: 1em;padding: 0px 30px;">{{ 'addReason' | translate }}</button>
                                </div>
                              </div>
                              <div class="row">
                                <div *ngIf="startFetchingData" style="width: 100%;height: 100%;left: 0;background: white;padding-bottom: 8em;    z-index: 999;">
                                  <div class="col-md-12" style="text-align: center;">
                                    <img src="assets/img/search_icon_animation.gif" style="width: 300px;">
                                    <h3 style="margin-top: -2em;color: #a1a1a1;font-weight: 400;">{{ 'pleaseWait' | translate }}</h3>
                                  </div>
                                </div>
                                <div *ngIf="noDataFound" class="col-md-12 text-center" style="color: teal;padding: 3em;">
                                  <h3 style="font-weight: 900;letter-spacing: 1px;">{{ 'thereAreNoAnyReasonsCreatedYet' | translate }}</h3>
                                </div>
                                <div *ngIf="dataFound" id="reason_manage_sms" class="col-md-12 table-responsive" style="padding: 1em 2em;">
                                  <table id="reason_manage_sms_list" class="table table-striped" cellspacing="0" width="100%" role="grid">
                                    <thead>
                                    <tr>
                                      <th>{{ 'reason' | translate }}</th>
                                      <th>{{ 'createdOn' | translate }}</th>
                                      <th>{{ 'manage' | translate }}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr *ngFor="let sl of fetchReasonToGetAllList" style="text-align:left" >
                                      <td>{{sl.reason}}</td>
                                      <td>{{sl.createdOn | date:'yMMMd'}}</td>
                                      <td>
                                        <a style="cursor: pointer;text-decoration: underline;font-size: 18px;"><i class="fa fa-pencil-square-o" aria-hidden="true" data-toggle="modal" (click)="getReasonId(sl)" data-target="#update_reason_for_sms"></i></a>
                                        <a style="cursor: pointer;text-decoration: underline;margin-left: 2em;font-size: 18px;"><i class="fa fa-trash-o" aria-hidden="true" data-toggle="modal" (click)="getReasonId(sl)" data-target="#delete_reason_for_sms"></i></a>
                                      </td>
                                    </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div><!--end .card-body -->
                    </div>
                  </div>
                </div>
                <!-- For sms_messaging-->
              </div><!--end .card-body -->
            </div><!--end .card -->
          </div><!--end .col -->
          <!-- END LAYOUT LEFT SIDEBAR -->
        </div>
        <!--  -->
      </section>
    </div><!--end #content-->
    <!-- END CONTENT -->

    <!-- Menubar -->
    <!--  -->

    <!--OFFCANVAS-->
    <div class="offcanvas">
      <div id="particularSmsCanvas" class="offcanvas-pane width-12" style="width:500px;overflow-x: hidden;">
        <div class="offcanvas-head" style="    padding: 0;">
          <div class="particles-bg row" style="background: var(--secondary-btn-bg-color);min-height: 260px;">
            <div class="particles-content">
              <div class="col-md-12" style="position: fixed;z-index: 999;top: 0em;">
                <h3 class="pull-right" style="color: white;cursor: pointer;" data-dismiss="offcanvas"><i class="fa fa-close"></i></h3>
              </div>
              <div class="col-md-12 text-center" style="position: absolute;top: 1em;">
                <p class="lead text-center" style="color: #ffffff;text-transform: uppercase; letter-spacing: 1px;margin-bottom: 10px;">{{ 'sendMessage' | translate }}</p>
                <img src="../../images_ext/chat.png" class="img-responsive" style="margin: 0 auto;width: 75px;">
                <p style="margin: 15px 0px; color: white; font-weight: 100;">{{ 'viewSelectedClassDetailsHere' | translate }}</p>
                <!--<div class="row">
                  <p class="lead" style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;"><span style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">Class Name</span><br>{{classStandardName}}</p>
                  <p class="lead" style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;"><span style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">Category</span><br>{{getViewCatName}}</p>
                  <p class="lead" style="color: white;font-size: 20px;display: inline-block;text-transform: uppercase;text-align: left;font-weight: 500;padding: 0px 50px;"><span style="font-size: 12px;background: white;color: var(--secondary-btn-bg-color);padding: 1px 10px;text-transform: lowercase;border-radius: 10px;">Total sections</span><br>{{getCategoryClassListtotalSections}}</p>
                </div>-->
              </div>
            </div>
          </div>

          <div class="row" style="background: #f1f1f1;">
            <div class="col-md-12 text-center">
              <h4 class="lead" style="margin: 10px 10px;color: var(--secondary-btn-bg-color);letter-spacing: 1px;font-size: 12px;text-transform: uppercase;font-weight: 500;">{{ 'sendMessageToStaff' | translate }}</h4>
            </div>
          </div>
          <div class="row" style="padding: 0 2em;">
            <form>
              <label class="form-group col-md-12" style="padding-top: 1em;">
                <select name="reason" class="form-control" style="color: darkgrey">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
              </label>
              <div class="form-group col-md-12" style="padding-top: 2em;">
                <textarea class="form-control" placeholder="Type your message here" name="message" rows="3" style="color: darkgrey;"></textarea>
              </div>
              <div class="col-md-12 text-right">
                <button type="button" class="btn btn-raised ink-reaction btn-info" data-toggle="modal" data-target="#smsAlertModel" aria-expanded="true">{{ 'sendMessage' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

    <!--start of modal for sms-->
    <div class="modal fade" id="schoolWiseSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em;margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
            <h3>{{ 'schoolWiseSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="smsclose" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required id="reasonSms" name="type" [(ngModel)]="schoolWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="schoolWiseSms.message" id="messageBody" name="messageBody" style="font-size: small;">
                <label for="messageBody" style="font-size: small;">{{ 'message' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="sendSmsSchool" (click)="sendSmsForSelectedFilter()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="classWiseSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em;margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
            <h3>{{ 'classWiseSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="smsclose1" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required id="reasonSms1" name="type" [(ngModel)]="classWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms1" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="classWiseSms.message" id="messageBody1" name="messageBody1" style="font-size: small;">
                <label for="messageBody" style="font-size: small;">{{ 'message' | translate }}"<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="sendSmsClass" (click)="sendSmsForSelectedFilter()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="studentWiseSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
      <div class="modal-content">
        <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
          <h3>{{ 'studentWiseSms' | translate }}</h3>
          <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
        </div>
        <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
          <button id="smsclose2" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
          <form class="form" role="form">
            <div class="form-group">
              <select required id="reasonSms2" [(ngModel)]="studentWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                <option value="0">{{ 'selectReason' | translate }}</option>
                <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
              </select>
              <label for="reasonSms2" style="font-size: small;">{{ 'reason' | translate }}</label>
            </div>
            <div class="form-group">
              <input type="text" class="form-control" [(ngModel)]="studentWiseSms.message" id="messageBody2" name="messageBody2" style="font-size: small;">
              <label for="messageBody2" style="font-size: small;">{{ 'message' | translate }}<span style="color: #F44336;">*</span></label>
            </div>

            <div class="text-center" style="padding: 8px 0px;">
              <button type="button" id="sendSmsStudent" (click)="sendStudentWiseSms()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </div>
    <div class="modal fade" id="appUserSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
            <h3>{{ 'appUserSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="smsclose4" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required id="reasonSms4" [(ngModel)]="studentWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms4" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="studentWiseSms.message" id="messageBody3" name="messageBody3" style="font-size: small;">
                <label for="messageBody3" style="font-size: small;">{{ 'message' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="appUserSms" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="nonAppUserSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
            <h3>{{ 'nonAppUserSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="smsclose5" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required id="reasonSms5" [(ngModel)]="studentWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms2" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="studentWiseSms.message" id="messageBody5" name="messageBody5" style="font-size: small;">
                <label for="messageBody5" style="font-size: small;">{{ 'message' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="nonAppUser1" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="staffWiseSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
            <h3>{{ 'staffWiseSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="smscloseforstaff" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required  name="type" [(ngModel)]="schoolWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="schoolWiseSms.message"  name="messageBody" style="font-size: small;">
                <label for="messageBody" style="font-size: small;">{{ 'message' | translate }}"<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="sendSmsSchoolStaff" (click)="sendSmsForSelectedFilter()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="selectedForDesignationWiseSmsForstaff_des" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em;margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 82.4px 0em;width: 30%">
            <h3>{{ 'designationWiseSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="designationWiseSmsFor_staff" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required  name="type" [(ngModel)]="schoolWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="schoolWiseSms.message"  name="messageBody" style="font-size: small;">
                <label for="messageBody" style="font-size: small;">{{ 'message' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="selectedForDesignationWiseSmsForstaff_desBtn" (click)="sendSmsForSelectedFilter()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="selectiveStaffWiseSmsModal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 93.4px 0em;width: 30%">
            <h3>{{ 'staffWiseSms' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="smsclose2staff" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <select required id="reasonSms22" [(ngModel)]="schoolWiseSms.reasonId" name="reason" class="form-control startpoint"  style="font-size: small;">
                  <option value="0">{{ 'selectReason' | translate }}</option>
                  <option *ngFor="let r of reasonList" value="{{r.pk_reasonId}}">{{r.reason}}</option>
                </select>
                <label for="reasonSms2" style="font-size: small;">{{ 'reason' | translate }}</label>
              </div>
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="schoolWiseSms.message" id="messageBody22" name="messageBody2" style="font-size: small;">
                <label for="messageBody2" style="font-size: small;">{{ 'message' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" id="sendSmsStaf" (click)="sendStaffWiseSmsSelective()" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="createReason" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 57.4px 0em;width: 30%">
            <h3>{{ 'createReason' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="createReason_btn" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="create_Reason" name="messageBody" style="font-size: small;">
                <label for="messageBody" style="font-size: small;">{{ 'reason' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" (click)="createReason()" id="createReasonSendButton" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'send' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="update_reason_for_sms" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-right: 26em; margin-top: 13em;">
        <div class="modal-content">
          <div class="col-md-6 text-center" style="background-color:var(--brand-primary-color);color: white;padding: 57.4px 0em;width: 30%">
            <h3>{{ 'editReason' | translate }}</h3>
            <hr style="border-top-color: #88c6f7; width: 50%; margin-top: 0;    margin-bottom: 0;">
          </div>
          <div class="col-md-6" style="background-color: white;padding: 2em 1em;width: 40%">
            <button id="update_reason_btn" style="background-color: var(--brand-primary-color);margin-right: -2em;margin-top: -3em;float: right;border: none;" type="button" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal" aria-hidden="true">&times;</button>
            <form class="form" role="form">
              <div class="form-group">
                <input type="text" class="form-control" [(ngModel)]="update_Reason" name="messageBody" style="font-size: small;">
                <label for="messageBody" style="font-size: small;">{{ 'reason' | translate }}<span style="color: #F44336;">*</span></label>
              </div>

              <div class="text-center" style="padding: 8px 0px;">
                <button type="button" (click)="updateReason()" id="updateReasonBtnSend" class="btn btn-raised ink-reaction btn-info" style="padding: 3px 20px;">{{ 'update' | translate }}</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div id="delete_reason_for_sms" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog" style="margin-top: 8em;">
        <div class="modal-content">
          <div class="modal-body">
            <h3 style="margin: 0;font-weight: 100;color: #909090;"><i class="fa fa-user-times" style="color:var(--secondary-btn-bg-color);"></i> {{ 'deleteSection' | translate }}</h3>
            <button id="delete_close_btn" class="btn ink-reaction btn-floating-action btn-primary" data-dismiss="modal"  style="background: var(--secondary-btn-bg-color);float: right;margin-top: -3em;margin-right: -2em;border: none;" type="button">×</button>
            <p style="font-size: 19px;margin-left: 6pc;padding: 29px 30px;">{{ 'areYouConfirmToDeleteTheReason' | translate }}</p>
            <div style="padding:0px 205px;    margin-top: -12px;">
              <button (click)="deleteReason()" class="btn btn-info btn-sm" style="width: 67px;">{{ 'ok' | translate }}</button>
              <button id="deletepopupclose" class="btn btn-info btn-sm" data-dismiss="modal">{{ 'cancel' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--View details for sms start-->
    <div class="modal fade" id="viewDetailsForSms" tabindex="-1" role="dialog" aria-labelledby="simpleModalLabel" aria-hidden="true">
      <div class="modal-dialog" style="width: 65%;">
        <div class="modal-content">
          <div class="modal-header" style="padding: 0px 25px;">
            <button type="button" id="closeViewDetailsForSms" class="close" data-dismiss="modal" aria-hidden="true" style="margin: 0;margin-top: -1em;background: var(--brand-primary-color);color: white;padding: 20px 15px;box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.33);opacity: inherit;">&times;</button>
            <div class="row">
              <div class="col-md-10 col-md-offset-1" style="text-align:center;">
                <h3 class="text-primary" style="text-transform: uppercase;color:rgb(88, 88, 88);font-weight: 900;margin: 19px;"><span style="font-size: 1.5em;margin-right: 10px;color: #656565;border: 1px solid #656565;border-radius: 50%;padding: 10px 13px;"><i class="fa fa-envelope"></i></span>{{ 'viewSentSmsDetails' | translate }} <span id="view_det_sms"></span></h3>
                <!--<p style="margin: 0;color: #989898;margin-top: 15px;margin-bottom: 10px;">View History for <b>{{getTypeName}}</b></p>-->
              </div>
            </div>
          </div>
          <div class="modal-body" style="background: #fbfbfb;padding: 1px;">
            <div class="col-md-12">
              <div class="row">
                <div [style.display]="studentListTable ? '':'none'" class="table-responsive" style="padding: 1em 1em;">
                  <table id="View_sms_details_new" class="table table-striped" style="width: 100% !important;">
                    <thead>
                    <tr>
                      <th>{{ 'studentName' | translate }}</th>
                      <th>{{ 'rollNumber' | translate }}</th>
                      <th>{{ 'class' | translate }}</th>
                      <th>{{ 'mobileNumber' | translate }}</th>
                      <th>{{ 'smsStatus' | translate }}</th>
                      <!--<th class="col-md-2" style="border-right: 1px solid #b9b6b6;border-bottom: 1px solid #b9b6b6;width: 10%;overflow: hidden !important;text-overflow: ellipsis;white-space: nowrap;">Success Status</th>-->
                    </tr>
                    </thead>
                  </table>
                </div>
                <div [style.display]="staffListTable ? '':'none'" class="table-responsive" style="padding: 1em 1em;">
                  <table id="staffListMessageTable" class="table table-striped" style="width: 100% !important;">
                    <thead>
                    <tr>
                      <th>{{ 'staffName' | translate }}</th>
                      <th>{{ 'mobileNumber' | translate }}</th>
                      <th>{{ 'designation' | translate }}</th>
                      <th>{{ 'smsStatus' | translate }}</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div [style.display]="everyoneTableList ? '':'none'" class="table-responsive" style="padding: 1em 1em;">
                  <table id="everyoneMessageTable" class="table table-striped" style="width: 100% !important;">
                    <thead>
                    <tr>
                      <th style="display: none;">{{ 'userid' | translate }}</th>
                      <th>{{ 'staff/studentName' | translate }}</th>
                      <th>{{ 'userType' | translate }}</th>
                      <th>{{ 'mobileNumber' | translate }}</th>
                      <th>{{ 'designation/class' | translate }}</th>
                      <th>{{ 'smsStatus' | translate }}</th>
                    </tr>
                    </thead>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center;background:hsla(207, 84%, 57%, 0);">
            <p style="color: #717171;display: none;">© {{ '2019BluewingsAllRightReserved' | translate:{ brandName: brand.name } }}</p>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <!--View details for sms end-->
    <!--End of modal for sms-->
  </div><!--end #base-->
  <!-- END BASE -->
</div>
